import { SHOW_LINKED_ACCOUNT_TOOLTIP } from "./types";

export const setShowLinkedAccountTooltip = value => {
  return { type: SHOW_LINKED_ACCOUNT_TOOLTIP, payload: value };
};
